import {
  css,
} from 'styled-components';

import AvenirBold from '../assets/fonts/AvenirNextLTPro-Bold.woff';
import AvenirIt from '../assets/fonts/AvenirNextLTPro-It.woff';
import AvenirRegular from '../assets/fonts/AvenirNextLTPro-Regular.woff';

import KevitRegularEot from '../assets/fonts/KievitPro-Regular.eot';
import KevitRegularTtf from '../assets/fonts/KievitPro-Regular.ttf';
import KevitRegularWoff from '../assets/fonts/KievitPro-Regular.woff';

export default css`
  @font-face {
    font-family: avenir;
    font-style: normal;
    font-weight: bold;
    src: url('${AvenirBold}');
  }
  @font-face {
    font-family: avenir;
    font-style: italic;
    font-weight: normal;
    src: url('${AvenirIt}');
  }
  @font-face {
    font-family: avenir;
    font-style: normal;
    font-weight: normal;
    src: url('${AvenirRegular}');
  }
  @font-face {
    font-family: kievitpro;
    src: url('${KevitRegularEot}');
    src: local('☺'), url('${KevitRegularWoff}') format('woff'), url('${KevitRegularTtf}') format('truetype');
    font-style: normal;
    font-display: swap;
  }
`;
